module.exports = __webpack_public_path__ + "img/logo-candy.ed393003.png";